export var MULTI_SELECT_RENDER_CRITERIA = 10;